import Cookies from 'js-cookie'

const TimestampKey = 'Web-Timestamp'

export function getTimestamp() {
  return Cookies.get(TimestampKey)
}

export function setTimestamp(str) {
  return Cookies.set(TimestampKey, str)
}

export function removeTimestamp() {
  return Cookies.remove(TimestampKey)
}
